/** "City, State" from whichever parts are present; null when neither is. */
export const formatLocation = (city: string | null | undefined, state: string | null | undefined): string | null => {
  const parts = [city, state].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : null;
};

export default formatLocation;
